"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContent = void 0;
var getContent = function (props) {
    var content = null;
    if (props.children != null)
        content = props.children;
    if (props.content != null)
        content = props.content;
    return content;
};
exports.getContent = getContent;
//# sourceMappingURL=getContent.js.map